// extracted by mini-css-extract-plugin
export default {"addButton":"SchoolsTable_addButton__AZkaf","searchField":"SchoolsTable_searchField__PLdGm"};